import React from 'react'
import classnames from 'classnames'

const DashboardSkeleton = ({ sideMenuHidden = false, isBlurred = false }) => {
  return (
    <div
      className={classnames('dashboard-skeleton', {
        'dashboard-skeleton--collapsed': sideMenuHidden,
        'dashboard-skeleton--blurred': isBlurred
      })}
      aria-busy='true'
      aria-label='Loading dashboard...'
    >
      {/* ========================================================
          LEFT SIDEBAR SKELETON (Tools)
         ======================================================== */}
      <aside className='dashboard-skeleton__sidebar'>
        {/* 1. Toolbar */}
        <div className='dashboard-skeleton__toolbar'>
          <div className='dashboard-skeleton__toolbar-list'>
            <div className='dashboard-skeleton__toolbar-btn dashboard-skeleton__toolbar-btn--icon skeleton-shimmer' />
            <div className='dashboard-skeleton__toolbar-btn skeleton-shimmer' style={{ width: '44px' }} />
            <div className='dashboard-skeleton__toolbar-btn skeleton-shimmer' style={{ width: '52px' }} />
            <div className='dashboard-skeleton__toolbar-btn skeleton-shimmer' style={{ width: '48px' }} />
            <div className='dashboard-skeleton__toolbar-btn skeleton-shimmer' style={{ width: '48px' }} />
            <div className='dashboard-skeleton__toolbar-btn skeleton-shimmer' style={{ width: '44px' }} />
            <div className='dashboard-skeleton__toolbar-btn dashboard-skeleton__toolbar-btn--lang skeleton-shimmer' />
          </div>
          <div className='dashboard-skeleton__toolbar-btn dashboard-skeleton__toolbar-btn--icon dashboard-skeleton__toolbar-btn--toggle skeleton-shimmer' />
        </div>

        {/* 2. Map Item Controls (Search + Actions, Add Button, Quick filters) */}
        <div className='dashboard-skeleton__controls'>
          <div className='dashboard-skeleton__controls-filters'>
            <div className='dashboard-skeleton__search-input skeleton-shimmer' />
            <div className='dashboard-skeleton__controls-actions'>
              <div className='dashboard-skeleton__action-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__action-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__action-icon skeleton-shimmer' />
            </div>
          </div>
          <div className='dashboard-skeleton__add-btn skeleton-shimmer' />
          <div className='dashboard-skeleton__quick-filters'>
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
            <div className='dashboard-skeleton__filter-tag skeleton-shimmer' style={{ width: '28px' }} />
          </div>
        </div>

        {/* 3. Target Groups & Items List */}
        <div className='dashboard-skeleton__list'>
          <div className='dashboard-skeleton__section-heading'>
            <div className='dashboard-skeleton__heading-title skeleton-shimmer' style={{ width: '100px' }} />
            <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ width: '22px' }} />
          </div>

          {/* Target Group 1 (Expanded with nested items) */}
          <div className='dashboard-skeleton__group dashboard-skeleton__group--expanded'>
            <div className='dashboard-skeleton__group-header'>
              <div className='dashboard-skeleton__chevron skeleton-shimmer' />
              <div className='dashboard-skeleton__group-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__group-title skeleton-shimmer' style={{ width: '135px' }} />
              <div className='dashboard-skeleton__item-actions'>
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
                <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ width: '20px' }} />
              </div>
            </div>
            <div className='dashboard-skeleton__group-items'>
              <div className='dashboard-skeleton__item'>
                <div className='dashboard-skeleton__item-icon skeleton-shimmer' />
                <div className='dashboard-skeleton__item-title skeleton-shimmer' style={{ width: '115px' }} />
                <div className='dashboard-skeleton__item-stat skeleton-shimmer' style={{ width: '46px' }} />
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__item'>
                <div className='dashboard-skeleton__item-icon skeleton-shimmer' />
                <div className='dashboard-skeleton__item-title skeleton-shimmer' style={{ width: '130px' }} />
                <div className='dashboard-skeleton__item-stat skeleton-shimmer' style={{ width: '52px' }} />
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__item'>
                <div className='dashboard-skeleton__item-icon skeleton-shimmer' />
                <div className='dashboard-skeleton__item-title skeleton-shimmer' style={{ width: '100px' }} />
                <div className='dashboard-skeleton__item-stat skeleton-shimmer' style={{ width: '42px' }} />
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__item'>
                <div className='dashboard-skeleton__item-icon skeleton-shimmer' />
                <div className='dashboard-skeleton__item-title skeleton-shimmer' style={{ width: '120px' }} />
                <div className='dashboard-skeleton__item-stat skeleton-shimmer' style={{ width: '48px' }} />
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
              </div>
            </div>
          </div>

          {/* Target Group 2 (Collapsed) */}
          <div className='dashboard-skeleton__group'>
            <div className='dashboard-skeleton__group-header'>
              <div className='dashboard-skeleton__chevron-right skeleton-shimmer' />
              <div className='dashboard-skeleton__group-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__group-title skeleton-shimmer' style={{ width: '145px' }} />
              <div className='dashboard-skeleton__item-actions'>
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
                <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ width: '20px' }} />
              </div>
            </div>
          </div>

          {/* Target Group 3 (Collapsed) */}
          <div className='dashboard-skeleton__group'>
            <div className='dashboard-skeleton__group-header'>
              <div className='dashboard-skeleton__chevron-right skeleton-shimmer' />
              <div className='dashboard-skeleton__group-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__group-title skeleton-shimmer' style={{ width: '125px' }} />
              <div className='dashboard-skeleton__item-actions'>
                <div className='dashboard-skeleton__icon-tiny skeleton-shimmer' />
                <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ width: '20px' }} />
              </div>
            </div>
          </div>

          {/* My Data Section */}
          <div className='dashboard-skeleton__section-heading' style={{ marginTop: '14px' }}>
            <div className='dashboard-skeleton__heading-title skeleton-shimmer' style={{ width: '70px' }} />
          </div>
          <div className='dashboard-skeleton__group'>
            <div className='dashboard-skeleton__group-header'>
              <div className='dashboard-skeleton__group-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__group-title skeleton-shimmer' style={{ width: '110px' }} />
              <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ marginLeft: 'auto', width: '20px' }} />
            </div>
            <div className='dashboard-skeleton__group-header'>
              <div className='dashboard-skeleton__group-icon skeleton-shimmer' />
              <div className='dashboard-skeleton__group-title skeleton-shimmer' style={{ width: '118px' }} />
              <div className='dashboard-skeleton__badge skeleton-shimmer' style={{ marginLeft: 'auto', width: '20px' }} />
            </div>
          </div>
        </div>

        {/* 4. Bottom Map Settings & Upgrade Banner */}
        <div className='dashboard-skeleton__bottom'>
          <div className='dashboard-skeleton__map-settings-row'>
            <div className='dashboard-skeleton__map-btn skeleton-shimmer' />
            <div className='dashboard-skeleton__map-btn skeleton-shimmer' />
            <div className='dashboard-skeleton__map-btn skeleton-shimmer' />
          </div>
          <div className='dashboard-skeleton__upgrade-card skeleton-shimmer' />
        </div>
      </aside>

      {/* ========================================================
          RIGHT SIDEBAR SKELETON (PointOfInterest & PeopleDataSidebar)
         ======================================================== */}
      <aside className='dashboard-skeleton__right-sidebar'>
        {/* 1. Vertical Action Tabs (INFO, POI, PEOPLE, INCOME) */}
        <div className='dashboard-skeleton__poi-tabs'>
          <div className='dashboard-skeleton__poi-tab-btn'>
            <div className='dashboard-skeleton__poi-tab-icon skeleton-shimmer' />
            <div className='dashboard-skeleton__poi-tab-label skeleton-shimmer' style={{ width: '32px' }} />
          </div>
          <div className='dashboard-skeleton__poi-tab-btn'>
            <div className='dashboard-skeleton__poi-tab-icon skeleton-shimmer' />
            <div className='dashboard-skeleton__poi-tab-label skeleton-shimmer' style={{ width: '26px' }} />
          </div>
          <div className='dashboard-skeleton__poi-tab-btn dashboard-skeleton__poi-tab-btn--active'>
            <div className='dashboard-skeleton__poi-tab-icon skeleton-shimmer' />
            <div className='dashboard-skeleton__poi-tab-label skeleton-shimmer' style={{ width: '42px' }} />
          </div>
          <div className='dashboard-skeleton__poi-tab-btn'>
            <div className='dashboard-skeleton__poi-tab-icon skeleton-shimmer' />
            <div className='dashboard-skeleton__poi-tab-label skeleton-shimmer' style={{ width: '44px' }} />
          </div>
        </div>

        {/* 2. Right Data Panel (People Demographic Sidebar) */}
        <div className='dashboard-skeleton__right-panel'>
          {/* Panel Header */}
          <div className='dashboard-skeleton__panel-header'>
            <div className='dashboard-skeleton__panel-header-left'>
              <div className='dashboard-skeleton__panel-title skeleton-shimmer' style={{ width: '80px' }} />
              <div className='dashboard-skeleton__panel-subtitle-row'>
                <div className='dashboard-skeleton__folder-icon skeleton-shimmer' />
                <div className='dashboard-skeleton__panel-subtitle skeleton-shimmer' style={{ width: '150px' }} />
                <div className='dashboard-skeleton__share-icon skeleton-shimmer' />
              </div>
            </div>
            <div className='dashboard-skeleton__panel-close skeleton-shimmer' />
          </div>

          <div className='dashboard-skeleton__panel-content'>
            {/* Overview Section */}
            <div className='dashboard-skeleton__panel-section'>
              <div className='dashboard-skeleton__section-title-row'>
                <div className='dashboard-skeleton__section-name skeleton-shimmer' style={{ width: '70px' }} />
                <div className='dashboard-skeleton__dataset-dropdown skeleton-shimmer' style={{ width: '100px' }} />
              </div>
              <div className='dashboard-skeleton__overview-grid'>
                <div className='dashboard-skeleton__metric-card'>
                  <div className='dashboard-skeleton__metric-val skeleton-shimmer' style={{ width: '70px' }} />
                  <div className='dashboard-skeleton__metric-lbl skeleton-shimmer' style={{ width: '60px' }} />
                </div>
                <div className='dashboard-skeleton__metric-card'>
                  <div className='dashboard-skeleton__metric-val skeleton-shimmer' style={{ width: '60px' }} />
                  <div className='dashboard-skeleton__metric-lbl skeleton-shimmer' style={{ width: '72px' }} />
                </div>
              </div>
            </div>

            {/* Trends Chart Section */}
            <div className='dashboard-skeleton__panel-section'>
              <div className='dashboard-skeleton__section-title-row'>
                <div className='dashboard-skeleton__section-name skeleton-shimmer' style={{ width: '120px' }} />
                <div className='dashboard-skeleton__year-pill skeleton-shimmer' style={{ width: '75px' }} />
                <div className='dashboard-skeleton__expand-btn skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__chart-card'>
                <div className='dashboard-skeleton__chart-y-axis'>
                  <div className='dashboard-skeleton__axis-tick skeleton-shimmer' />
                  <div className='dashboard-skeleton__axis-tick skeleton-shimmer' />
                  <div className='dashboard-skeleton__axis-tick skeleton-shimmer' />
                </div>
                <div className='dashboard-skeleton__chart-body'>
                  <div className='dashboard-skeleton__chart-grid-line' />
                  <div className='dashboard-skeleton__chart-grid-line' />
                  <div className='dashboard-skeleton__chart-grid-line' />
                  {/* Stylized trend wave */}
                  <svg className='dashboard-skeleton__chart-svg' viewBox='0 0 280 80' preserveAspectRatio='none'>
                    <path
                      d='M 0 65 Q 45 50, 90 45 T 180 30 T 280 15'
                      fill='none'
                      stroke='#E2E8F0'
                      strokeWidth='3'
                      strokeLinecap='round'
                    />
                    <path
                      d='M 0 65 Q 45 50, 90 45 T 180 30 T 280 15 L 280 80 L 0 80 Z'
                      fill='url(#chart-grad-shimmer)'
                      opacity='0.4'
                    />
                    <defs>
                      <linearGradient id='chart-grad-shimmer' x1='0' y1='0' x2='0' y2='1'>
                        <stop offset='0%' stopColor='#CBD5E1' stopOpacity='0.5' />
                        <stop offset='100%' stopColor='#CBD5E1' stopOpacity='0' />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
              </div>
              <div className='dashboard-skeleton__chart-x-axis'>
                <div className='dashboard-skeleton__axis-tick-x skeleton-shimmer' style={{ width: '32px' }} />
                <div className='dashboard-skeleton__axis-tick-x skeleton-shimmer' style={{ width: '32px' }} />
                <div className='dashboard-skeleton__axis-tick-x skeleton-shimmer' style={{ width: '32px' }} />
                <div className='dashboard-skeleton__axis-tick-x skeleton-shimmer' style={{ width: '32px' }} />
              </div>
            </div>

            {/* Key Metrics Section */}
            <div className='dashboard-skeleton__panel-section'>
              <div className='dashboard-skeleton__section-name skeleton-shimmer' style={{ width: '85px', marginBottom: '8px' }} />
              <div className='dashboard-skeleton__overview-grid'>
                <div className='dashboard-skeleton__metric-card'>
                  <div className='dashboard-skeleton__metric-val skeleton-shimmer' style={{ width: '75px' }} />
                  <div className='dashboard-skeleton__metric-lbl skeleton-shimmer' style={{ width: '50px' }} />
                </div>
                <div className='dashboard-skeleton__metric-card'>
                  <div className='dashboard-skeleton__metric-val skeleton-shimmer' style={{ width: '65px' }} />
                  <div className='dashboard-skeleton__metric-lbl skeleton-shimmer' style={{ width: '60px' }} />
                </div>
              </div>
            </div>

            {/* Gender Section */}
            <div className='dashboard-skeleton__panel-section'>
              <div className='dashboard-skeleton__section-title-row'>
                <div className='dashboard-skeleton__section-name skeleton-shimmer' style={{ width: '130px' }} />
                <div className='dashboard-skeleton__expand-btn skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__gender-bar-wrapper'>
                <div className='dashboard-skeleton__gender-bar skeleton-shimmer' />
                <div className='dashboard-skeleton__gender-stats'>
                  <div className='dashboard-skeleton__gender-stat-item'>
                    <div className='dashboard-skeleton__gender-bullet skeleton-shimmer' />
                    <div className='dashboard-skeleton__gender-label skeleton-shimmer' style={{ width: '65px' }} />
                  </div>
                  <div className='dashboard-skeleton__gender-stat-item'>
                    <div className='dashboard-skeleton__gender-bullet skeleton-shimmer' />
                    <div className='dashboard-skeleton__gender-label skeleton-shimmer' style={{ width: '70px' }} />
                  </div>
                </div>
              </div>
            </div>

            {/* Population Pyramid Section */}
            <div className='dashboard-skeleton__panel-section' style={{ borderBottom: 'none' }}>
              <div className='dashboard-skeleton__section-title-row'>
                <div className='dashboard-skeleton__section-name skeleton-shimmer' style={{ width: '105px' }} />
                <div className='dashboard-skeleton__expand-btn skeleton-shimmer' />
              </div>
              <div className='dashboard-skeleton__pyramid-card'>
                <div className='dashboard-skeleton__pyramid-row'>
                  <div className='dashboard-skeleton__pyramid-bar-left skeleton-shimmer' style={{ width: '38%' }} />
                  <div className='dashboard-skeleton__pyramid-label skeleton-shimmer' style={{ width: '34px' }} />
                  <div className='dashboard-skeleton__pyramid-bar-right skeleton-shimmer' style={{ width: '42%' }} />
                </div>
                <div className='dashboard-skeleton__pyramid-row'>
                  <div className='dashboard-skeleton__pyramid-bar-left skeleton-shimmer' style={{ width: '56%' }} />
                  <div className='dashboard-skeleton__pyramid-label skeleton-shimmer' style={{ width: '34px' }} />
                  <div className='dashboard-skeleton__pyramid-bar-right skeleton-shimmer' style={{ width: '58%' }} />
                </div>
                <div className='dashboard-skeleton__pyramid-row'>
                  <div className='dashboard-skeleton__pyramid-bar-left skeleton-shimmer' style={{ width: '78%' }} />
                  <div className='dashboard-skeleton__pyramid-label skeleton-shimmer' style={{ width: '34px' }} />
                  <div className='dashboard-skeleton__pyramid-bar-right skeleton-shimmer' style={{ width: '82%' }} />
                </div>
                <div className='dashboard-skeleton__pyramid-row'>
                  <div className='dashboard-skeleton__pyramid-bar-left skeleton-shimmer' style={{ width: '62%' }} />
                  <div className='dashboard-skeleton__pyramid-label skeleton-shimmer' style={{ width: '34px' }} />
                  <div className='dashboard-skeleton__pyramid-bar-right skeleton-shimmer' style={{ width: '66%' }} />
                </div>
                <div className='dashboard-skeleton__pyramid-row'>
                  <div className='dashboard-skeleton__pyramid-bar-left skeleton-shimmer' style={{ width: '44%' }} />
                  <div className='dashboard-skeleton__pyramid-label skeleton-shimmer' style={{ width: '34px' }} />
                  <div className='dashboard-skeleton__pyramid-bar-right skeleton-shimmer' style={{ width: '48%' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>
    </div>
  )
}

export default DashboardSkeleton
